var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"title"},[_c('span',{staticClass:"title__indicator",class:{
				'title__indicator--red': _vm.color === 'red',
				'title__indicator--blue': _vm.color === 'blue',
			}},[_vm._v(_vm._s(_vm.indicator))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]),_c('div',{staticClass:"indented"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }